import { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { useEditSubCategoryMutation } from "../../../features/api/subcategoryApi";

const UpdateSubCategory = ({ subCategory }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };

  const [updateSubcategory] = useEditSubCategoryMutation();
  const [sub_catName, setSubCategory] = useState("");

  useEffect(() => {
    if (subCategory) {
      setSubCategory(subCategory?.sub_catName);
    }
  }, [subCategory]);

  const handleUpdate = async (id) => {
    try {
      const data = {
        id,
        sub_catName: sub_catName,
      };

      const response = await updateSubcategory(data);
      if (response) {
        setIsOpen(false);
        document.body.style.overflow = "auto";
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };
  return (
    <div>
      <span onClick={openModal}>
        <FaEdit className="text-xl text-blue-500 font-bold cursor-pointer" />
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-slate-200 p-6 rounded shadow-md md:w-[500px]">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-4 w-full">
              <div className="card-body">
                <div
                  className="flex flex-col items-start font-extralight p-4 "
                  style={{ lineHeight: "30px" }}
                >
                  <div className="flex flex-col gap-4 w-full">
                    <div className="flex flex-col justify-between">
                      <label className="font-bold">Update Brand:</label>
                      <input
                        type="text"
                        value={sub_catName}
                        onChange={(e) => setSubCategory(e.target.value)}
                        className="border pl-1 focus:outline-none bg-slate-50"
                      />
                    </div>
                  </div>
                  <button
                    onClick={() => handleUpdate(subCategory?.id)}
                    className="bg-green-500 text-white font-bold mt-4 px-2 rounded block m-auto"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateSubCategory;
